<template>
  <div class="collaborate-detail"
    v-show="loaded">
    <img src="../assets/imgs/collaborate-detail-1.png">
    <img src="../assets/imgs/collaborate-detail-2.png">
    <img :src="qrCodeUrl"
      class="qrcode">
    <div class="text">
      <p>长按识别二维码领取</p>
      <p>领取截止日期: {{endDate}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qrCodeUrl: '',
      endTimeMills: '',
      loaded: false,
    };
  },
  computed: {
    endDate() {
      const date = new Date(this.endTimeMills);
      const YYYY = date.getFullYear();
      const HH = (date.getMonth() + 1).toString().padStart(2, '0');
      const DD = date.getDate().toString().padStart(2, '0');
      return `${YYYY}年${HH}月${DD}日`;
    },
  },
  created() {
    this.qrCodeUrl = this.$route.query.qrCodeUrl;
    this._fetch('/gw/salaryempapi/readPack/getRedRecordInfo', {
      uuid: this.$route.query.uuid,
    }).then((res) => {
      if (res.data.state === 1) {
        this.$router.replace({
          path: '/activity-error',
          query: {
            errorType: 2,
          },
        });
        return;
      }
      this.endTimeMills = res.data.endTimeMills;
      if (this.endTimeMills < Date.now()) {
        this.$router.replace({
          path: '/activity-error',
          query: {
            errorType: 1,
          },
        });
        return;
      }
      this.loaded = true;
    });
  },
};
</script>

<style lang="stylus" scoped>
.collaborate-detail
  background-color #EA3728
  position relative
  img
    display block
    width 100%
  .qrcode
    width 400px
    height 400px
    position absolute
    top 510px
    left 50%
    transform translateX(-50%)
  .text
    position absolute
    top 952px
    left 50%
    transform translateX(-50%)
    color #EA3728
    font-size 36px
    font-weight bold
    text-align center
    p
      line-height 46px
      margin-bottom 20px
      white-space nowrap
</style>